import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { SgoSituacoesDemanda } from '../models/sgo-situacoes-demanda';

@Injectable({
  providedIn: 'root',
})
export class SgoSituacoesDemandaService extends BaseService<SgoSituacoesDemanda> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/sgo-situacoes-demanda';
  }
}
